import { SaleBookDetailProps } from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/interface'
import SaleBookTableRow from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/components/SaleBookTableRow'
import LoadingGate from '@components/LoadingGate/LoadingGate'
import { Loading } from '@components/Loading'
import { ProductTypeSummary } from '@hooks/writer/useWriterAction'
import { showCommaFromString } from '@lib/utils'
import { SHOW_EBOOK_FEATURE } from '@configs/config'
import { Table } from './components/Table'

const saleTypeMapper = SHOW_EBOOK_FEATURE
  ? {
      [ProductTypeSummary.NOVEL_CHAPTER]: '1. ขายนิยายรายตอน',
      [ProductTypeSummary.MANGA_CHAPTER]: '2. รายได้จากการ์ตูนรายตอน',
      [ProductTypeSummary.NOVEL_EBOOK]: '3. รายได้จากอีบุ๊กนิยาย',
      [ProductTypeSummary.MANGA_EBOOK]: '4. รายได้จากอีบุ๊กการ์ตูน',
      [ProductTypeSummary.DONATION]: '5. รายได้จากการสนับสนุน',
    }
  : {
      [ProductTypeSummary.NOVEL_CHAPTER]: '1. ขายนิยายรายตอน',
      [ProductTypeSummary.MANGA_CHAPTER]: '2. รายได้จากการ์ตูนรายตอน',
      [ProductTypeSummary.DONATION]: '3. รายได้จากการสนับสนุน',
    }

const SaleBookDetail = ({
  type,
  data,
  userId,
  dateSelected,
  isLoading,
  isFetchingNextPage,
  handleFetchNextPage,
}: SaleBookDetailProps) => {
  return (
    <LoadingGate isLoading={isLoading}>
      <div className='mt-[40px] overflow-x-scroll'>
        <div className='font-bold dark:text-white-2'>
          {saleTypeMapper[type]}
        </div>

        <Table
          className='w-[1104px] max-h-[500px]'
          onScroll={handleFetchNextPage}
        >
          <Table.Row className='sticky top-0 z-10'>
            <Table.Header className='border-b border-b-gray-3 dark:border-purple bg-white dark:bg-dark-9 py-[10px] flex items-center'>
              เรื่อง
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-purple bg-white dark:bg-dark-9 text-right py-[10px]'>
              ราคาขาย
              <br />
              (บาท)
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-purple bg-white dark:bg-dark-9 text-right py-[10px]'>
              จำนวน
              <br />
              (ครั้ง)
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-purple bg-white dark:bg-dark-9 text-right py-[10px]'>
              ยอดขายรวม
              <br />
              (บาท)
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-purple bg-white dark:bg-dark-9 text-right py-[10px]'>
              รายได้เจ้าของงานเขียน
              <br />
              (บาท)
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-purple bg-white dark:bg-dark-9' />
          </Table.Row>

          {data?.pages &&
            data.pages
              .map(row => row.salesDetail)
              .flatMap(row => row.data)
              .map((row, index) => (
                <SaleBookTableRow
                  key={row.id}
                  data={row}
                  dateSelected={dateSelected}
                  type={type}
                  userId={userId}
                />
              ))}
          {isFetchingNextPage ? (
            <div className='flex justify-center'>
              <Loading />
            </div>
          ) : null}

          <Table.Row className='sticky bottom-0'>
            <Table.Footer className='pl-[20px] py-[16px] text-left dark:text-dark-10 dark:bg-dark-8'>
              รายได้รวม
            </Table.Footer>
            <Table.Footer className='dark:text-dark-10 dark:bg-dark-8' />
            <Table.Footer className='py-[16px] text-right dark:text-dark-10 dark:bg-dark-8'>
              {data?.pages &&
                data.pages.length > 0 &&
                data.pages[
                  data.pages.length - 1
                ].purchasedCount.toLocaleString()}
            </Table.Footer>
            <Table.Footer className='py-[16px] text-right dark:text-dark-10 dark:bg-dark-8'>
              {showCommaFromString(
                data?.pages && data.pages.length > 0
                  ? data.pages[data.pages.length - 1].sales
                  : undefined
              )}
            </Table.Footer>
            <Table.Footer className='py-[16px] text-right dark:text-dark-10 dark:bg-dark-8'>
              {showCommaFromString(
                data?.pages && data.pages.length > 0
                  ? data.pages[data.pages.length - 1].writerIncome
                  : undefined
              )}
            </Table.Footer>
            <Table.Footer className='dark:text-dark-10 dark:bg-dark-8' />
          </Table.Row>
        </Table>
      </div>
    </LoadingGate>
  )
}

export default SaleBookDetail
